import { Box, Stack, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { FormattedMessage, FormattedNumber } from "react-intl";

function PricesWednesday() {
  return (
    <Stack spacing="1.5rem">
      <Box>
        <Text fontSize="1.25rem" fontWeight={500} lineHeight="1.75rem">
          <FormattedMessage defaultMessage="Tarifs mercredi unitaire" />
        </Text>

        <Table>
          <Tbody>
            <Tr>
              <Td width="45%" borderBottomWidth="2px" pl="0"></Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Plein tarif" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Tarif réduit" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="45%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Résidents de Golbey et Chantraine" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber
                    value={6.36}
                    style="currency"
                    currency="EUR"
                  />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber
                    value={5.46}
                    style="currency"
                    currency="EUR"
                  />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="45%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Extérieur" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber
                    value={6.82}
                    style="currency"
                    currency="EUR"
                  />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber
                    value={5.9}
                    style="currency"
                    currency="EUR"
                  />
                </Text>
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>

      <Box>
        <Text fontSize="1.25rem" fontWeight={500} lineHeight="1.75rem">
          <FormattedMessage defaultMessage="Suppléments" />
        </Text>

        <Table>
          <Tbody>
            <Tr>
              <Td width="45%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Garderie 18h30-19h" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber value={1} style="currency" currency="EUR" />

                  <FormattedMessage defaultMessage=" / ¼ d'heure" />
                </Text>
              </Td>
            </Tr>

            <Tr>
              <Td width="45%" borderBottomWidth="2px" pl="0">
                <Text fontSize="1rem" fontWeight={600} lineHeight="1.5rem">
                  <FormattedMessage defaultMessage="Temps de midi" />
                </Text>
              </Td>

              <Td borderBottomWidth="2px" pr="0">
                <Text fontSize="1rem" fontWeight={400} lineHeight="1.5rem">
                  <FormattedNumber
                    value={0.91}
                    style="currency"
                    currency="EUR"
                  />
                </Text>
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </Box>
    </Stack>
  );
}

export default PricesWednesday;
